import React from 'react';
import { Film, Sparkles, ArrowRight } from 'lucide-react';
import './Hero.css';

export const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <div className="container">
          <div className="hero-badge">
            <Film size={20} />
            <span>8+ Years of Excellence</span>
          </div>
          
          <h1 className="hero-title">
            RSE <span className="hero-divider">|</span> Post Production House
          </h1>
          
          <p className="hero-tagline">
            Unleashing creativity, one frame at a time
          </p>
          
          <p className="hero-description">
            Professional remote video editing services for wedding filmmakers, studios, and brands worldwide. 
            Serving clients across the USA, UK, Canada & Australia with a dedicated team of expert editors.
          </p>
          
          <div className="hero-cta-group">
            <a href="/contact" className="btn btn-primary btn-large">
              <span>Get A Free Consultation</span>
              <ArrowRight size={20} />
            </a>
            <a href="/portfolio" className="btn btn-outline btn-large">
              <span>View Our Work</span>
              <Sparkles size={20} />
            </a>
          </div>
          
          <div className="hero-stats">
            <div className="hero-stat">
              <div className="hero-stat-number">5630+</div>
              <div className="hero-stat-label">Projects Delivered</div>
            </div>
            <div className="hero-stat">
              <div className="hero-stat-number">100%</div>
              <div className="hero-stat-label">Client Satisfaction</div>
            </div>
            <div className="hero-stat">
              <div className="hero-stat-number">8+</div>
              <div className="hero-stat-label">Expert Editors</div>
            </div>
          </div>

          <p className="hero-trust-line">
            Trusted by wedding studios, filmmakers & brands across the USA, UK, Canada & Australia
          </p>
        </div>
      </div>
      
      {/* Film reel decorative elements - hidden */}
    </section>
  );
};
